import React, { Component } from 'react'
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { blue, white, red } from './Colors.js';

const theme = createTheme({
  palette: {
    primary: {
      main: blue,
      light: white,
    },
    blue: {
      main: blue
    },
    secondary: {
      main: white
    },
    error: {
      main: red,
      contrastText: white
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        a: {
          color: blue
        },
      }
    }
  },
  typography: {
    overline: {
      color: blue
    }
  },
});

class Theme extends Component {

  render () {
    return <ThemeProvider theme={theme}>
      {this.props.children}
    </ThemeProvider>
  }

}

export default Theme;